import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ typography }: Theme) =>
  createStyles({
    cardContent: {
      padding: '20px 24px 7px 7px !important',
      justifyContent: 'center ',
    },
    header: {
      padding: '5px 0px 0px 7px',
      '& .MuiTypography-root': {
        fontWeight: typography.fontWeightMedium,
        fontSize: 15,
      },
      '& .MuiCardHeader-subheader': {
        fontSize: 12,
        opacity: 0.5,
      },
    },

    value: {
      fontSize: 22,
      justifyContent: 'center',
      display: 'flex',
      fontWeight: 500,
      color: palette.gray,
      lineHeight: 1,
      marginBottom: 15,

      '& small': {
        display: 'block',
        fontSize: 25,
        paddingBottom: 5,
      },
    },
    valueGray: {
      color: palette.navSuperAdminActions,
    },
    valueYellow: {
      color: palette.navCompanyContextActions,
    },
    valueGreen: {
      color: palette.navAdminActions,
    },
    valueBlue: {
      color: palette.navOperatorActions,
    },
  });
